import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { BehaviorSubject, catchError, filter, Observable, switchMap, take, throwError } from 'rxjs';
import { AuthService } from '../api-services/AdminHRService/Login/auth.service';
import { TALENT_NOVA_REQUEST } from './talent-nova-context';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  private isRefreshing = false;
  private refreshSubject = new BehaviorSubject<string | null>(null);

  constructor(private authService: AuthService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    if (req.context.get(TALENT_NOVA_REQUEST) || req.url.includes('RefreshToken')) {
      return next.handle(req);
    }

    const token = this.authService.getAccessToken();

    if (token) {
      req = this.addToken(req, token);
    }

    return next.handle(req).pipe(
      catchError(error => {

        if (error.status === 401) {
          return this.handle401Error(req, next);
        }

        return throwError(() => error);
      })
    );
  }


  private handle401Error(req: HttpRequest<any>, next: HttpHandler) {

    if (!this.isRefreshing) {

      this.isRefreshing = true;
      this.refreshSubject.next(null);

      return this.authService.refreshToken().pipe(

        switchMap(res => {

          const newToken = res?.data?.accessToken;

          if (!newToken) {
            this.authService.logout();
            return throwError(() => new Error('Refresh failed'));
          }

          this.isRefreshing = false;

          this.authService.setAccessToken(newToken);
          this.refreshSubject.next(newToken);

          return next.handle(this.addToken(req, newToken));
        }),

        catchError(err => {

          this.isRefreshing = false;
          this.authService.logout();

          return throwError(() => err);
        })
      );
    }

    return this.refreshSubject.pipe(
      filter(token => token != null),
      take(1),
      switchMap(token => next.handle(this.addToken(req, token!)))
    );
  }

  private addToken(req: HttpRequest<any>, token: string) {

    return req.clone({
      setHeaders: { Authorization: `Bearer ${token}` }
    });
  }
}
